export var getBoxClasses = function (props, context) { return ({
    class: [
        // Flexbox & Alignment
        'tw-flex tw-items-center tw-justify-center',
        // Sizing & Shape
        'tw-size-5 tw-rounded tw-border',
        // Colors & States
        'tw-text-white',
        {
            'tw-bg-white dark:tw-bg-zinc-500 tw-border-zinc-400 dark:tw-border-zinc-400': !context.checked && !props.disabled,
            'tw-bg-primary-500 dark:tw-bg-primary-400 tw-border-primary-500 dark:tw-border-primary-400': context.checked && !props.disabled,
            // Disabled unchecked: muted gray fill (not white)
            'tw-bg-gray-100 tw-border-gray-300 dark:tw-bg-zinc-600 dark:tw-border-zinc-500': !context.checked && props.disabled,
            // Disabled checked: faded primary
            'tw-bg-primary-500 tw-border-primary-500 tw-opacity-60 dark:tw-bg-primary-400 dark:tw-border-primary-400': context.checked && props.disabled,
            'tw-border-red-500 dark:tw-border-red-400': props.invalid,
        },
        // Hover & Focus Styles
        {
            'peer-hover:tw-border-primary-500': !props.disabled && !context.checked && !props.invalid,
            'peer-hover:tw-border-primary-400': !props.disabled && context.checked,
            'peer-focus-visible:tw-border-primary-500 dark:peer-focus-visible:tw-border-primary-400 peer-focus-visible:tw-ring-2 peer-focus-visible:tw-ring-primary-400/20 dark:peer-focus-visible:tw-ring-primary-300/20': !props.disabled,
        },
        // Disabled State
        {
            'tw-cursor-default': props.disabled,
        },
        // Animation
        'tw-transition-colors tw-duration-200',
    ],
}); };
export var getInputClasses = function (props) { return ({
    class: [
        // Position & Visibility
        'tw-peer tw-w-full tw-h-full tw-absolute tw-top-0 tw-left-0 tw-z-10',
        // Spacing & Appearance — !opacity beats legacy components.css `input[type=checkbox]:disabled { opacity: .9 }`
        'tw-p-0 tw-m-0 !tw-opacity-0 tw-rounded-md tw-outline-none',
        // Borders
        'tw-border-2 tw-border-zinc-200 dark:tw-border-zinc-700',
        'tw-appearance-none',
        // Cursor States
        {
            'tw-cursor-not-allowed': props.disabled,
            'tw-cursor-pointer': !props.disabled,
        },
    ],
}); };
export var getIconClasses = function () { return ({
    class: [
        // Typography & Sizing
        'tw-text-base tw-leading-none tw-size-3.5',
        // Colors
        'tw-text-white dark:tw-text-gray-900',
        // Animation
        'tw-transition-all tw-duration-200',
    ],
}); };
export var CHECKBOX_ICON_CLASSES = [
    // Typography & Sizing
    'tw-text-base tw-leading-none tw-size-3.5',
    // Colors
    'tw-text-white dark:tw-text-gray-900',
    // Animation
    'tw-transition-all tw-duration-200',
];
